// Used as vuex store module path
const MODULE_ID = 'fahrdienst452';
export default MODULE_ID;
  
  
